// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__tO3G6","modalHeader":"styles_modalHeader__Bay1S","closeButton":"styles_closeButton__oVwhw"};